<div class="flex items-center justify-between w-full">
  <div class="instruction-box">
    <p>Click on a nest to move SKUs between nests</p>
  </div>
  <div class="nest-group-actions">
    @if (!showLoader) {
      <div class="nest-summary-toolbar">
        <div class="nest-summary-filters">
          @if (appliedFilters.length > 0) {
            <div class="applied-filters">
              <span class="filters-label">Filters Applied :</span>
              @for (
                filter of appliedFilters;
                track filter.key + ":" + filter.value
              ) {
                <span class="filter-chip">
                  {{ filter.label }} : {{ filter.value }}
                  <img
                    src="/assets/images/cross-icon.svg"
                    alt="Remove"
                    class="remove-filter"
                    (click)="removeFilter(filter.key, filter.value)"
                  />
                </span>
              }
            </div>
          }
        </div>
        <div class="nest-summary-action-controls">
          @if (!lockAssortment) {
            <app-edit-modify-button
              (actionButtonCall)="onModifyClick()"
              [disabled]="accessType === 'read'"
            ></app-edit-modify-button>
          }
          <img
            [src]="
              appliedFilters.length > 0
                ? '/assets/images/icon-filter-applied.svg'
                : '/assets/images/icon-filter.svg'
            "
            alt="Filter"
            class="filter-icon"
            (click)="openFilterPanel($event)"
          />
          <app-download-btn
            [showLoader]="downloadLoader"
            (actionBtnCallback)="onDownloadClick($event)"
          ></app-download-btn>
        </div>
      </div>
    } @else {
      <p-skeleton width="100px" height="36px" styleClass="mb-2"></p-skeleton>
    }
  </div>
</div>

<div
  class="cards-container"
  [ngStyle]="{ 'grid-template-columns': 'repeat(' + cols + ', 1fr)' }"
>
  @if (!showLoader && paginatedCards.length === 0) {
    <div class="no-nests-message">
      <div class="no-nests-header">No nests available</div>
      <div class="no-nests-text">There are no nests to display.</div>
    </div>
  }

  @for (c of paginatedCards; track c) {
    <div
      class="card"
      (click)="!lockAssortment && accessType !== 'read' && moveSku(c)"
      [style.cursor]="!lockAssortment ? 'pointer' : 'default'"
    >
      @if (!showLoader) {
        <div class="card-header">
          <div class="card-header-info">
            <span class="card-header-text">Nest {{ c.header.nestNumber }}</span>
            <span class="card-header-sub-text">
              PPL Range: {{ c.header.pplRange }} | Beer Types:
              {{ c.header.beerType }}
            </span>
          </div>
        </div>
        <div class="card-stats">
          @for (s of c.stats; track s) {
            <div>
              <span class="stat-label">{{ s.label }}</span
              ><br />
              <span class="stat-value">{{ s.value }}</span>
            </div>
          }
        </div>
        <div class="table-container">
          <table class="card-table">
            <thead>
              <tr>
                @for (col of c.columns; track col) {
                  <th>{{ col }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of c.rows; track row) {
                <tr>
                  <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
                  <td>{{ row.price_per_ltr }}</td>
                  <td>{{ row.ptc_segment }}</td>
                  <td>{{ row.brand }}</td>
                </tr>
              }
              @if (c.rows.length === 0) {
                <tr>
                  <td colspan="4" class="empty-placeholder">
                    <div class="empty-placeholder-header">No SKUs to show</div>
                    <div class="empty-placeholder-text">
                      Please add some SKUs to the list
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p-skeleton height="240px" width="100%" styleClass="mb-4"></p-skeleton>
      }
    </div>
  }
</div>

@if (!showLoader && paginatedCards.length > 0) {
  <div class="pagination-footer">
    <div class="footer-left">
      <label>
        Items per page
        <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
          @for (size of pageSizes; track size) {
            <option [value]="size">
              {{ size }}
            </option>
          }
        </select>
      </label>
      <span
        >{{ startIndex + 1 }}–{{ endIndex }} of {{ totalItems }} entries</span
      >
    </div>
    <div class="footer-right">
      <button (click)="prevPage()" [disabled]="currentPage === 1">‹</button>
      <span>
        Page
        <input
          type="number"
          [(ngModel)]="currentPage"
          (change)="onPageInputChange($event)"
          class="page-input"
          [min]="1"
          [max]="totalPages"
        />
        of {{ totalPages }}
      </span>
      <button (click)="nextPage()" [disabled]="currentPage === totalPages">
        ›
      </button>
    </div>
  </div>
}

<p-dialog
  [(visible)]="showMoveSkuPopup"
  [modal]="true"
  [style]="{ width: '60vw', minWidth: '1000px' }"
  [baseZIndex]="10000"
  [dismissableMask]="false"
  [closable]="false"
  contentStyleClass="custom-dialog-content"
  headerClass="custom-dialog-header"
>
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center w-full">
      <p class="header-text">Move SKUs</p>
      <img
        src="/assets/images/cross-icon.svg"
        alt="Close"
        class="cursor-pointer w-4 h-4"
        (click)="onMoveSkuDialogClose()"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    @if (tempSelectedCardConfig && !showLoader) {
      <div class="dialog-two-cols" [class.dragging]="isDragging">
        <!-- LEFT SIDE -->
        <div class="dialog-card dialog-left">
          <div class="dialog-container">
            <div class="card-header">
              <div class="card-header-info">
                <span class="card-header-text"
                  >Nest {{ tempSelectedCardConfig.header.nestNumber }}</span
                >
                <span class="card-header-sub-text">
                  PPL Range: {{ tempSelectedCardConfig.header.pplRange }} | Beer
                  Types: {{ tempSelectedCardConfig.header.beerType }}
                </span>
              </div>
            </div>
            <div class="card-stats">
              @for (s of tempSelectedCardConfig.stats; track s) {
                <div>
                  <span class="stat-label">{{ s.label }}</span
                  ><br />
                  <span class="stat-value">{{ s.value }}</span>
                </div>
              }
            </div>
            <div class="table-container">
              <table class="card-table">
                <thead>
                  <tr>
                    @for (col of tempSelectedCardConfig.columns; track col) {
                      <th>
                        {{ col }}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody
                  cdkDropList
                  id="selectedCardDropList"
                  [cdkDropListData]="tempSelectedCardConfig.rows"
                  [cdkDropListConnectedTo]="cardDropListIds"
                  (cdkDropListDropped)="onDrop($event, 'selected')"
                >
                  @for (row of tempSelectedCardConfig.rows; track row) {
                    <tr
                      cdkDrag
                      (cdkDragStarted)="onDragStarted()"
                      (cdkDragEnded)="onDragEnded()"
                    >
                      <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
                      <td>{{ row.price_per_ltr }}</td>
                      <td>{{ row.ptc_segment }}</td>
                      <td>{{ row.brand }}</td>
                      <ng-template cdkDragPreview>
                        <div class="drag-preview-row">
                          <div class="cell">
                            {{ row.sku_detail }}<br />{{ row.sku }}
                          </div>
                          <div class="cell">{{ row.price_per_ltr }}</div>
                          <div class="cell">{{ row.ptc_segment }}</div>
                          <div class="cell">{{ row.brand }}</div>
                        </div>
                      </ng-template>
                    </tr>
                  }
                  @if (tempSelectedCardConfig.rows.length === 0) {
                    <tr>
                      <td colspan="4" class="empty-placeholder">
                        <div class="empty-placeholder-header">
                          No SKUs to show
                        </div>
                        <div class="empty-placeholder-text">
                          Please add some SKUs to the list
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- RIGHT SIDE -->
        <div class="dialog-card dialog-right-scrollable">
          <div class="nest-group-actions">
            <div class="nest-groups-wrapper">
              @for (nestGroup of nestGroupsList; track nestGroup) {
                <div class="nest-groups">
                  <button
                    [ngClass]="{
                      selected: popupActiveNestGroup?.value === nestGroup.value,
                    }"
                    class="nest-group-button"
                    (click)="toggleNestGroupInPopup(nestGroup)"
                  >
                    <span
                      [ngClass]="{
                        'selected-text':
                          popupActiveNestGroup?.value === nestGroup.value,
                      }"
                      class="nest-group-button-text"
                    >
                      {{ nestGroup.label }}
                    </span>
                  </button>
                </div>
              }
            </div>
            <button class="add-button" (click)="addNewNest()">
              Add new nest
            </button>
          </div>
          <p class="helper-text">
            Drag and drop the SKU from left to any nest group of your choice
          </p>
          @for (card of tempCardConfigs; track card; let i = $index) {
            <div [ngStyle]="{ 'margin-top': i === 0 ? '12px' : '16px' }">
              <p-accordion>
                <p-accordionTab>
                  <ng-template pTemplate="header">
                    <div class="card-header">
                      <div class="card-header-info">
                        <span class="card-header-text"
                          >Nest {{ card.header.nestNumber }}</span
                        >
                        @if (!isPlaceholderStats(card.stats)) {
                          <span class="card-header-sub-text">
                            PPL Range: {{ card.header.pplRange }} | Beer Types:
                            {{ card.header.beerType }}
                          </span>
                        }
                      </div>
                      <div class="card-header-icons">
                        <img
                          src="/assets/images/chart-toggler.svg"
                          class="toggler-icon"
                        />
                      </div>
                    </div>
                  </ng-template>
                  <div class="card-stats">
                    @for (s of card.stats; track s) {
                      <div>
                        <span class="stat-label">{{ s.label }}</span
                        ><br />
                        <span class="stat-value">{{ s.value }}</span>
                      </div>
                    }
                  </div>
                  <div class="table-container">
                    <table class="card-table">
                      <thead>
                        <tr>
                          @for (col of card.columns; track col) {
                            <th>{{ col }}</th>
                          }
                        </tr>
                      </thead>
                      <tbody
                        cdkDropList
                        [id]="'cardDropList' + i"
                        [cdkDropListData]="card.rows"
                        [cdkDropListConnectedTo]="['selectedCardDropList']"
                        (cdkDropListDropped)="onDrop($event, i)"
                      >
                        @for (row of card.rows; track row) {
                          <tr
                            cdkDrag
                            (cdkDragStarted)="onDragStarted()"
                            (cdkDragEnded)="onDragEnded()"
                          >
                            <td>{{ row.sku_detail }}<br />{{ row.sku }}</td>
                            <td>{{ row.price_per_ltr }}</td>
                            <td>{{ row.ptc_segment }}</td>
                            <td>{{ row.brand }}</td>
                            <ng-template cdkDragPreview>
                              <div class="drag-preview-row">
                                <div class="cell">
                                  {{ row.sku_detail }}<br />{{ row.sku }}
                                </div>
                                <div class="cell">{{ row.price_per_ltr }}</div>
                                <div class="cell">{{ row.ptc_segment }}</div>
                                <div class="cell">{{ row.brand }}</div>
                              </div>
                            </ng-template>
                          </tr>
                        }
                        @if (card.rows.length === 0) {
                          <tr>
                            <td colspan="4" class="empty-placeholder">
                              <div class="empty-placeholder-header">
                                No SKUs to show
                              </div>
                              <div class="empty-placeholder-text">
                                Please add some SKUs to the list
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </p-accordionTab>
              </p-accordion>
            </div>
          }
        </div>
      </div>
    } @else {
      <p-skeleton width="100%" height="400px"></p-skeleton>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 footer-buttons">
      <app-button-secondary
        (actionButtonCall)="onMoveSkuDialogClose()"
        buttonCaption="Cancel"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="Save"
        (actionButtonCall)="onPopUpSave()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>

<p-overlayPanel
  #filterPanel
  (onShow)="onFilterPanelShow()"
  (onHide)="onFilterPanelHide()"
>
  <div class="summary-filter-container">
    <div class="summary-filter-header">
      <div class="header-text">Filter By</div>
      <img
        src="/assets/images/cross-icon.svg"
        alt="Cross"
        class="cross-icon"
        (click)="filterPanel.hide()"
      />
    </div>
    <div class="summary-filter-content">
      @if (showAccordion) {
        <p-accordion
          [multiple]="true"
          class="custom-filter-accordion"
          [activeIndex]="activeAccordionIndex"
        >
          @for (cfg of filterConfigs; track cfg) {
            <p-accordionTab>
              <ng-template pTemplate="header">
                <div class="filter-title">
                  <img
                    src="/assets/images/frame-icon.svg"
                    alt="Frame"
                    class="frame-icon"
                  />
                  <span>{{ cfg.label }}</span>
                </div>
              </ng-template>
              <div class="filter-body">
                <div class="filter-count">
                  {{ filters[cfg.key].selected.length }} Selected
                </div>
                <div class="search-container">
                  <div class="search-input-wrapper">
                    <img
                      src="/assets/images/search.svg"
                      alt="Search"
                      class="search-icon"
                    />
                    <input
                      type="text"
                      placeholder="Search"
                      [(ngModel)]="filters[cfg.key].search"
                      class="search-input"
                    />
                  </div>
                </div>
                <div class="filter-list">
                  @for (item of filteredItems(cfg.key); track item) {
                    <div
                      class="filter-item"
                      (click)="toggleSelection(cfg.key, item)"
                      [class.selected]="
                        filters[cfg.key].selected.includes(item)
                      "
                    >
                      {{ item }}
                    </div>
                  }
                </div>
              </div>
            </p-accordionTab>
          }
        </p-accordion>
      }
    </div>
    <div class="summary-filter-footer">
      <div class="flex justify-end gap-2 footer-buttons filter-buttons">
        <app-button-secondary
          (actionButtonCall)="clearFilter()"
          buttonCaption="Clear"
        ></app-button-secondary>
        <app-button-primary
          buttonCaption="Apply"
          (actionButtonCall)="onFilterApply()"
        ></app-button-primary>
      </div>
    </div>
  </div>
</p-overlayPanel>

<p-dialog
  header="You have unsaved changes. Are you sure you want to leave without saving?"
  [(visible)]="showUnsavedChangesDialog"
  [style]="{ width: '32vw' }"
  [modal]="true"
  [draggable]="false"
>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="showUnsavedChangesDialog = false"
        buttonCaption="Cancel"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="Confirm"
        (actionButtonCall)="closeDialog()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
